'use strict';

/**
 * @ngdoc function
 * @name myConsultApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'editActivityTypeCtrl',
    function ($scope, $routeParams, crumble, ActivityTypeService) {
      if (!$scope.isSuperUser) {
        $location.path('/find-a-pet');
      }

      $scope.crumble = crumble;
      crumble.update();

      $scope.activityId = $routeParams.activityId;
      $scope.activityForm = {};
      $scope.activityForm.title = '';
      $scope.classifications = [];
      $scope.frequencyPeriods = [];
      $scope.activityForm.classification = {};
      $scope.activityForm.classification.id = '';
      $scope.activityForm.description = '';
      $scope.activityForm.date_start = null;
      $scope.activityForm.num_points = '';
      $scope.activityForm.date_end = null;
      $scope.activityForm.manual_trigger_enabled = false;
      $scope.activityForm.admin_only = false;
      $scope.activityForm.allow_negative_points = false;
      $scope.activityForm.frequency_cap = null;
      $scope.activityForm.frequency_period = null;
      $scope.activityForm.extra_data = null;
      $scope.isFrequencyLimited = false;
      $scope.frequency_cap = 1;
      $scope.frequency_period = '';
      $scope.extra_data = [];
      $scope.extra_key = '';
      $scope.extra_value = '';
      $scope.submit = {
        success: false,
      };

      $scope.addExtraItem = function () {
        $scope.extraKeyError = false;
        $scope.extraValueError = false;
        if ($scope.extra_key && $scope.extra_value) {
          $scope.extra_data.push({ key: $scope.extra_key, value: $scope.extra_value });
          $scope.extra_key = '';
          $scope.extra_value = '';
        }
        if (!$scope.extra_key) {
          $scope.extraKeyError = true;
        }
        if (!$scope.extra_value) {
          $scope.extraValueError = true;
        }
      };

      $scope.deleteExtraItem = function (key) {
        if (key) {
          $scope.extra_data = $scope.extra_data.filter(function (item) {
            return item.key != key;
          });
        }
      };

      $scope.isInvalidDate = function () {
        if (
          $scope.activityForm.date_start != null &&
          $scope.activityForm.date_end != null &&
          new Date($scope.activityForm.date_start) > new Date($scope.activityForm.date_end)
        ) {
          $scope.dateErrorMsg = 'End Date should be greater than start date';
          return true;
        }
        $scope.dateErrorMsg = '';
        return false;
      };

      $scope.isPromotionCode = function (classificationId) {
        for (var i = 0; i < $scope.classifications.length; i++) {
          if (
            $scope.classifications[i].id == classificationId &&
            $scope.classifications[i].name.includes('Promotion Code')
          ) {
            return true;
          }
        }
        return false;
      };

      $scope.updateActivityType = function () {
        if ($scope.isFrequencyLimited == false) {
          $scope.activityForm.frequency_cap = null;
          $scope.activityForm.frequency_period = null;
        } else {
          $scope.activityForm.frequency_cap = $scope.frequency_cap;
          $scope.activityForm.frequency_period = {};
          $scope.activityForm.frequency_period.id = $scope.frequency_period;
        }

        $scope.activityForm.extra_data = {};
        $scope.extra_data.forEach(function (item) {
          $scope.activityForm.extra_data[item.key] = item.value;
        });

        if ($scope.isPromotionCode($scope.activityForm.classification.id)) {
          $scope.activityForm.num_points = null;
          $scope.activityForm.frequency_cap = null;
          $scope.activityForm.frequency_period = null;
          $scope.activityForm.date_start = null;
          $scope.activityForm.date_end = null;
        }

        if ($scope.activityId == 'create') {
          ActivityTypeService.createActivityType({
            activities: $scope.activityForm,
          }).then(function () {
            $scope.submit.success = true;
          });
        } else {
          ActivityTypeService.updateActivityType($scope.activityId, {
            activities: $scope.activityForm,
          }).then(function () {
            $scope.submit.success = true;
          });
        }
      };

      $scope.$on('$viewContentLoaded', function () {
        if ($scope.activityId != 'create') {
          ActivityTypeService.getActivityType($scope.activityId).then(function (response) {
            $scope.activityForm = response.activities;

            if ($scope.activityForm.frequency_cap == null) {
              $scope.isFrequencyLimited = false;
            } else {
              $scope.isFrequencyLimited = true;
              $scope.frequency_cap = parseInt($scope.activityForm.frequency_cap, 10);
              $scope.frequency_period = $scope.activityForm.frequency_period.id;
            }

            $scope.extra_data = [];
            Object.keys($scope.activityForm.extra_data).forEach(function (item) {
              $scope.extra_data.push({ key: item, value: $scope.activityForm.extra_data[item] });
            });

            $scope.activityForm.date_start = new Date($scope.activityForm.date_start);
            $scope.activityForm.date_end = new Date($scope.activityForm.date_end);
          });
        }
        ActivityTypeService.getClassifications().then(function (response) {
          $scope.classifications = response.classifications;
        });
        ActivityTypeService.getFrequencyPeriods().then(function (response) {
          $scope.frequencyPeriods = response['frequency-periods'];
        });
      });
    },
  );
